<template>
  <main class="container-selfservice-main">
    <h1 class="tit-h2 mb-9">{{ t('support_center') }}</h1>
    <h4 class="medium mb-4">{{ t('ss_title_faq') }}</h4>
    <div class="web-tab-wrap">
      <InputFilter v-model="items" />
    </div>
    <div class="contact-qna-warp" :key="qnas.length">
      <ContactQna :qnas="qnas" />
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import ContactQna from '@/components/domains/self-service/contact/ContactQna.vue';
import InputFilter from '@/components/shared/base/InputFilter.vue';
import { QnaItem } from '@/types/components';
import { ACCOUNT_SUBSCRIPTION_QNA, INTERPRETATION_QNA } from '@/utils/constants/qna';

const { t } = useI18n();

const items = ref([
  {
    label: 'label_all',
    value: 'ALL',
    isChecked: true,
  },
  {
    label: 'label_interpretation',
    value: 'INTERPRETATION',
    isChecked: false,
  },
  {
    label: 'ss_title_subscription_account',
    value: 'ACCOUNT_SUBSCRIPTION',
    isChecked: false,
  },
]);

const qnas = computed<QnaItem[]>(() => {
  const qnaMap = {
    ALL: [...INTERPRETATION_QNA, ...ACCOUNT_SUBSCRIPTION_QNA],
    INTERPRETATION: INTERPRETATION_QNA,
    ACCOUNT_SUBSCRIPTION: ACCOUNT_SUBSCRIPTION_QNA,
  };

  return items.value.reduce((acc, item) => {
    if (item.isChecked) {
      acc.push(...qnaMap[item.value]);
    }
    return acc;
  }, []);
});
</script>

<style scoped lang="scss">
.container-selfservice-main {
  display: block;
  max-width: 1024px;
  margin: 0 auto;
  h1 {
    text-align: center;
  }
  .contact-qna-warp {
    padding: 2rem 0 4rem;
  }
}
</style>
